import { Field, Form } from "formik";
import styled from "styled-components";

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 7em 0 5em 0;
`;

export const HeaderStyle = styled.p`
  font-size: 18px;
  margin-top: 1.5%;
  margin-bottom: 5px;
`;

export const ProfileImageStyle = styled.img`
  max-height: 150px;
  max-width: 150px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: 3em 1em 0 0;
`;

export const ProfileDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
`;

export const ProfileHeader = styled.div`
  font-size: 38px;
  font-weight: bold;
`;

export const PassLabel = styled.label`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  margin: auto;
  /* identical to box height */

  padding: 10px;
  color: rgba(0, 0, 0, 0.7);
`;

export const EditInputSmall = styled(Field)`
  text-align: center;
  box-sizing: border-box;
  height: 30px;
  width: 200px;
  background: #ffffff;
  border: 2px solid #c4c4c4;
  border-radius: 6px;
`;

export const ChangePassForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  margin: 20px;
  padding-top: 10px;
  align-content: center;
  justify-content: center;
`;

export const ProfileContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: 2em 0 0 0;
`;

export const ProfileFields = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 2em;
`;

export const ProfileField = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 21px;
  padding: 1em;
`;

export const FieldHeader = styled.div`
  width: 9em;
  font-weight: bold;
`;

export const FieldContent = styled.div`
  width: 100%
`;